import React, { useEffect, useState } from "react";
import {
  jeepneyApplicationInit,
} from "./jeepneyGo/bridge";
import demoState, { globalData } from "./jeepneyGo/core/globalData";
import { demoState as demoStateCashCash } from "./cashCashPabunot/core/data";
import tuktukDemoState from "./TukTukGold/core/globalData";
import {
  cashCashApplicationInit,
} from "./cashCashPabunot/bridge";
import { networkData, pixiDiv } from "./cashCashPabunot/core/data";
import { tuktukApplicationInit } from "./TukTukGold/bridge";
import { globalData as tuktukData } from "./TukTukGold/core/globalData"; 
import { idleTimer } from "../utils/common.helper";
import { fruitFiestaApplicationInit } from "./fruitFiesta/bridge";
import fruitDemo, { fruitData } from "./fruitFiesta/core/data";

pixiDiv.width = window.innerWidth;
pixiDiv.height = window.innerHeight;

const PixiGame = ({ setSessionExpired }) => {
  const [baseGameId, setBaseGameId] = useState(null);
  const [isPixiAssetsLoaded, setIsPixiAssetsLoaded] = useState(false);
  const pixiStates = {
    setIsPixiAssetsLoaded,
    setSessionExpired,
  }
  const params = new URLSearchParams(window.location.search);

  const setDemo = (token) => {
    
      if(token === 'demo'){        
        demoStateCashCash.isDemo = true;
        demoState.isDemo = true;
        tuktukDemoState.isDemo = true;
        fruitDemo.isDemo = true;
      } else {
        demoStateCashCash.isDemo = false
        demoState.isDemo = false
        tuktukDemoState.isDemo = false
        fruitDemo.isDemo = false;
      }
   
    
  }

  useEffect(() => {
    idleTimer()
  }, [])

  useEffect(() => {
    setBaseGameId(params.get("baseGameId"));
    if (baseGameId == 1) {
      document.title = "Jeepney";
    } else if (baseGameId == 2) {
      document.title = "Cash-Cash";
    } else if(baseGameId == 3){
      document.title = "Tuk-Tuk"
    } else {
      document.title = "Slice-N-Go"
    }
  }, [baseGameId]);

  useEffect(() => {


    switch (Number(baseGameId)) {
      case 1:
        globalData.accessToken = params.get("token");
        globalData.currencyCode = params.get("currency");
        globalData.operatorId = params.get("operator");
        globalData.gameCode = params.get("gameId");
        setDemo(globalData.accessToken)
        if (!isPixiAssetsLoaded) jeepneyApplicationInit(pixiStates);
        break;

      case 2:
        networkData.operatorUserToken = params.get("token");
        networkData.currencyCode = params.get("currency");
        networkData.operatorId = params.get("operator");
        networkData.gameId = params.get("gameId");
        setDemo(networkData.operatorUserToken)

        if (!isPixiAssetsLoaded) cashCashApplicationInit(pixiStates);
        break;

      case 3:
        tuktukData.accessToken = params.get("token");
        tuktukData.currencyCode = params.get("currency");
        tuktukData.operatorId = params.get("operator");
        tuktukData.gameCode = params.get("gameId");
        setDemo(tuktukData.accessToken)
        if (!isPixiAssetsLoaded) tuktukApplicationInit(pixiStates);
        break;
        // else cashCashApplicationInit(setIsPixiAssetsLoaded);
      case 4:
        fruitData.accessToken = params.get("token");
        fruitData.currencyCode = params.get("currency");
        fruitData.operatorId = params.get("operator");
        fruitData.gameCode = params.get("gameId");
        setDemo(fruitData.accessToken)
        if (!isPixiAssetsLoaded) fruitFiestaApplicationInit(pixiStates);


      default:
        if (baseGameId !== null) console.error("BaseGameId: ", baseGameId);
        break;
    }

    return () => {
      // if(Number(baseGameId) == 1) jeepneyApplicationDestroy()
      // if(Number(baseGameId) == 2) cashCashApplicationDestroy()
    };
  }, [isPixiAssetsLoaded, baseGameId]);

  return <div id="pixi-game"></div>;
};

export default PixiGame;
